import React from "react";

/**
 * AIMKA monogram — Playfair "A" in an ink tile with a fine ochre underline.
 * Sized in px. Used on login screen, headers and (rasterised) as favicon.
 */
export default function Monogram({ size = 48, className = "" }) {
  const tile = size;
  const font = Math.round(size * 0.58);
  const under = Math.round(size * 0.42);
  return (
    <div className={`inline-flex flex-col items-center ${className}`}>
      <div
        className="rounded-[8px] flex items-center justify-center text-[var(--bg-app)]"
        style={{
          width: tile,
          height: tile,
          background: "var(--text-primary)",
          fontFamily: "\"Playfair Display\", serif",
          fontWeight: 700,
          fontSize: font,
          lineHeight: 1,
        }}
        aria-label="AIMKA"
      >
        A
      </div>
      <div
        className="mt-1"
        style={{ width: under, height: 2, background: "var(--accent)" }}
      />
    </div>
  );
}
